/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core"
import {
  Modal,
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
} from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants"
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
} from "App/utils/helpers"
import React, { useContext, useEffect, useState } from "react"
import { getTotal, getTotalFilterID, hitungDiskon, isExist } from "../.."
import { numberToFixed } from "../.."
import { FormContext } from "../../../context/FormContext"
import { v4 as uuidv4 } from "uuid"
import { MSG_NOT_MINUS } from "utils/all"
import AlertDiskon from "../../AlertDiskon"

export const urlGetFasilitasByKelas = "/penjualan/listFasilitasByKelasId"
export const urlDelete = "/penjualan/deleteFasilitas"
export const urlGet = "/penjualan/listFasilitasByPenjualanId"

export const RESET_STATE_DAFTAR_FASILITAS = {
  id: "",
  mh_fasilitas_id: "",
  fasilitas_id: "",
  qty: "",
  keterangan: "",
  harga: "",
  hargaCustom: "",
  hargaCustom2: "",
  kelas_id: "",

  namaFasilitas: "",

  nilai_diskon: 0, //hargaCustom*diskon/100
  total_harga_pokok: 0, //static
  total_harga_jual: 0, //(hargaCustom-nilai_diskon)*qty
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "40px",
  },
  {
    id: "namaMsFasilitas",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "harga_jual",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaJsFasilitas",
    disablePadding: false,
    label: "JENIS",
    align: "left",
    minWidth: "100px",
  },
]

export const deleteFasilitasById = async (formData) => {
  try {
    const res = await instance3.post(urlDelete, formData)

    if (res.data.status === 200) {
      return {
        state: true,
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getFasilitasByPenjualanID = async (id) => {
  try {
    const res = await instance3.get(`${urlGet}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        message: res.data.message,
      }
    } else if (res.data.status === 204) {
      return {
        state: true,
        data: [],
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getAllFasilitasByKelas = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post(`${urlGetFasilitasByKelas}`, {
      kelasId: formFilter.kelas_id,
      asuransiId: formFilter.asuransi_id,
      namaMsFasilitas: formFilter.name,
      halaman: pages,
      jumlah: limit,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const ModalDaftarFasilitas = ({
  setShowModal,
  formFasilitas,
  setFormFasilitas,
  setNewFasilitasDijual,
  setNewDataFasilitasByKelas,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (isNull(formFasilitas.qty)) {
        defaultToastError("Qty harus diisi")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        if (convertToValidPrice(formFasilitas.qty) > 0) {
          if (isNull(formFasilitas.id)) {
            const checkExist = isExist(
              formData.fasilitas,
              "mhFasilitasId",
              formFasilitas.mh_fasilitas_id,
            )
            if (checkExist) {
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
              return defaultToastError("fasilitas ini sudah ada di list")
            } else {
              await addFasilitas()
            }
          } else {
            const filterFasilitas = formData.fasilitas.filter(
              (e) => e.id !== formFasilitas.id,
            )
            const newSingleFasilitas = setSingleFasilitas("UPDATE")
            const newFasilitas = [...filterFasilitas, newSingleFasilitas]
            if (!isNull(formData.penjualan_id)) {
              await addFasilitasServer(
                newSingleFasilitas,
                "/penjualan/updateFasilitas",
              )
              setShowModal(false)
            } else {
              setNewFasilitasDijual(newFasilitas, false)
              setShowModal(false)
              defaultToastSuccess("Berhasil mengubah list fasilitas")
            }
          }
        } else {
          if (convertToValidPrice(formFasilitas.qty) < 0) {
            defaultToastError(MSG_NOT_MINUS)
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (convertToValidPrice(formFasilitas.qty) === 0) {
            defaultToastError("QTY tidak boleh 0")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (isNull(formFasilitas.hargaCustom)) {
            defaultToastError("Harga harus diisi")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            defaultToastError("Inputan tidak valid")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    setFormFasilitas({
      ...formFasilitas,
      hargaCustom: convertToValidPrice(formFasilitas.hargaCustom2),
    })
  }, [formFasilitas.hargaCustom2])

  const setSingleFasilitas = (type) => {
    const diskon =
      parseFloat(String(formFasilitas.diskon).replace(",", ".")) || 0
    const { nilaiDiskon, totalHargaJual, totalHargaPokok } = hitungDiskon(
      formFasilitas,
      "fasilitas",
    )
    const qty = convertToValidPrice(formFasilitas.qty)
    
    const singleFasilitas = {
      mhFasilitasId: formFasilitas.mh_fasilitas_id,
      qty: qty,
      keterangan: "",
      harga: formFasilitas.harga,
      hargaCustom: formFasilitas.hargaCustom,
      hargaCustom2: formFasilitas.hargaCustom2,
      total: formFasilitas.hargaCustom * qty,

      namaFasilitas: formFasilitas.namaFasilitas,
      fasilitas_id: formFasilitas.fasilitas_id,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,
      id_bed: formFasilitas.bed_id,

      diskon,
      nilai_diskon: nilaiDiskon,
      total_harga_pokok: totalHargaPokok,
      total_harga_jual: totalHargaJual,
    }

    let newSingleFasilitas
    if (type === "ADD") {
      newSingleFasilitas = {
        id: uuidv4(),
        ...singleFasilitas,
      }
    } else {
      newSingleFasilitas = {
        id: formFasilitas.id,
        ...singleFasilitas,
      }
    }

    return newSingleFasilitas
  }

  const addFasilitas = async () => {
    const newSingleFasilitas = setSingleFasilitas("ADD")
    const newFasilitas = [...formData.fasilitas, newSingleFasilitas]
    const reload = formData.reload_perhitungan || false
    await setFormData({
      ...formData,
      fasilitas: newFasilitas,
      reload_perhitungan: !reload,
    })

    if (!isNull(formData.penjualan_id)) {
      await addFasilitasServer(newSingleFasilitas, "/penjualan/addFasilitas")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    } else {
      defaultToastSuccess("Berhasil menambah fasilitas")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    }
    setNewFasilitasDijual(newFasilitas, false)
  }

  const addFasilitasServer = async (fasilitas, url) => {
    try {
      const totalFasilitas = await getTotalFilterID(
        formData.fasilitas,
        fasilitas.id,
        "fasilitas",
      )
      const hargaTotalFasilitas =
        fasilitas.qty * (fasilitas.hargaCustom - fasilitas.nilai_diskon) +
        totalFasilitas

      const totalBarang = getTotal(formData.barang, "barang")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalPaket = getTotal(formData.paket, "paket")

      const jumlah =
        totalBarang +
        totalRikjang +
        hargaTotalFasilitas +
        totalJasa +
        totalPaket

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const newFasilitas = {
        ...fasilitas,
        penjualanId: formData.penjualan_id,
        harga_total_fasilitas: numberToFixed(
          convertToValidPrice(hargaTotalFasilitas),
        ),
        total_Penjualan: numberToFixed(convertToValidPrice(jumlah)),
        sisa: numberToFixed(convertToValidPrice(total)),

        tax: taxPercent,
        jumlah_tax: numberToFixed(convertToValidPrice(taxNumber)),
        discount: numberToFixed(convertToValidPrice(formData.potongan / total)),
        jumlah_set_discount: potongan,
        hargaCustom: numberToFixed(fasilitas?.hargaCustom || 0),
        nilai_diskon: numberToFixed(fasilitas?.nilai_diskon || 0),
        total_harga_jual:
          numberToFixed(fasilitas?.hargaCustom || 0) -
          numberToFixed(fasilitas?.nilai_diskon || 0),
      }
      const res = await instance3.post(url, newFasilitas)
      if (res.data.status === 200) {
        defaultToastSuccess(res.data.message)
        setNewFasilitasDijual(newFasilitas, false)
        setNewDataFasilitasByKelas()
      } else {
        defaultToastError(res.data.message)
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  const optionBeds = (formFasilitas.bed || []).map((item) => ({
    id: item.id,
    label: item.nama_bed,
  }))

  return (
    <Modal
      title={`${titleModal(formFasilitas.id)} Fasilitas`}
      show={setShowModal}
    >
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        {formFasilitas.id && (
          <AlertDiskon defaultDiskon={formData.diskon?.diskon_fasilitas ?? 0} />
        )}
        <p className="mt-1 mb-1">{formFasilitas.namaFasilitas}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formFasilitas.id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name="qty"
              label="BANYAK"
              id="qty"
              value={formFasilitas.qty}
              onChange={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormFasilitas({
                    ...formFasilitas,
                    qty: formatRupiah(val, false),
                  })
                } else {
                  setFormFasilitas({
                    ...formFasilitas,
                    qty: val,
                  })
                }
              }}
              placeholder="Banyak"
              autoFocus={true}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="harga"
              label="HARGA"
              id="harga"
              placeholder="0"
              value={formFasilitas.hargaCustom2}
              onInput={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormFasilitas({
                    ...formFasilitas,
                    hargaCustom2: formatRupiah(val),
                  })
                } else {
                  setFormFasilitas({
                    ...formFasilitas,
                    hargaCustom2: val,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="discount-barang"
              label="DISKON (%)"
              id="discount-barang"
              value={formFasilitas.diskon}
              onChange={(e) => {
                const raw = e.target.value
                if (raw === "") {
                  return setFormFasilitas({ ...formFasilitas, diskon: "" })
                }
                if (/^[0-9]*([.,][0-9]*)?$/.test(raw)) {
                  if (convertToValidPrice(raw) > 100) {
                    return setFormFasilitas({ ...formFasilitas, diskon: 100 })
                  } else {
                    return setFormFasilitas({
                      ...formFasilitas,
                      diskon: formatRupiah(raw),
                    })
                  }
                }
              }}
              placeholder="15"
              error={convertToValidPrice(formFasilitas.diskon) > 100}
              message="Maksimal 100%"
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="nilai-discount"
              label="NILAI DISKON"
              id="nilai-discount"
              value={formatRupiah(
                numberToFixed(
                  convertToValidPrice(
                    (convertToValidPrice(formFasilitas.hargaCustom) *
                      (parseFloat(
                        String(formFasilitas.diskon).replace(",", "."),
                      ) || 0)) /
                      100,
                  ),
                ),
              )}
              disabled
              placeholder="Nilai Diskon"
            />
          </Grid>
          {optionBeds.length > 0 && (
            <Grid item sm={6}>
              <InputOptionMaster
                name="bed"
                label="NAMA BED"
                id="bed"
                data={optionBeds}
                withSearch={true}
                value={formFasilitas.bed_id}
                labelValue={formFasilitas.bed_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormFasilitas({
                      ...formFasilitas,
                      bed_id: null,
                      bed_name: "Pilih Bed",
                    })
                  } else {
                    setFormFasilitas({
                      ...formFasilitas,
                      bed_id: e?.id,
                      bed_name: e?.label,
                    })
                  }
                }}
              />
            </Grid>
          )}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}
